import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import fetchProduct from 'utils/fetch-product';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { IconPlus, IconLookRight } from 'utils/icon';
import ProductCard from '../utils/product-card';

const SimilarProducts = ({ title, handle }) => {
  const [products, setProducts] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandListings = () => {
    setIsExpanded(true);
  };
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let productIds = [];

    document.addEventListener('nosto-for-you-products', async (event) => {
      if (productIds?.length) return;

      const productList = [];
      productIds = event.detail.slice(0, 25);
      const getProducts = async () => {
        // eslint-disable-next-line consistent-return
        const fetchPromises = productIds.map(async (item) => {
          const { product: fetchedProduct } = await fetchProduct(item.handle);
          if (fetchedProduct) {
            return fetchedProduct;
          }
        });

        const fetchedProducts = await Promise.all(fetchPromises);
        fetchedProducts.forEach((product) => {
          if (product && !productList.some((p) => p.id === product.id)) {
            productList.push(product);
          }
        });
        setProducts(productList);
      };

      const fetchData = async () => {
        await getProducts();
        setIsLoading(false);
        setTimeout(() => {
          const rivoAccountWidget = document.getElementById(
            'rivo-account-slideout',
          );
          if (rivoAccountWidget) {
            window.RivoProfileAlpine.$data(
              rivoAccountWidget,
            ).initializeFavoriteButtons();
          }
        }, 200);
      };

      fetchData();
    });
  }, []);

  useEffect(() => {
    document.addEventListener('nosto:products-loaded', () => {});
  }, []);

  return (
    !isLoading &&
    products?.length > 0 && (
      <div className="py-5 lg:pt-10 lg:pb-[60px] w-full overflow-hidden">
        {title && (
          <h2 className="text-center mb-5 lg:mb-[30px] px-5 lg:px-10">
            {title}
          </h2>
        )}

        <div className="relative !px-5 lg:!px-10 w-full">
          <Swiper
            className={`!overflow-visible w-full lg:[&>.swiper-wrapper]:grid
            lg:[&>.swiper-wrapper]:grid-cols-5 lg:[&>.swiper-wrapper]:w-full
            lg:[&>.swiper-wrapper]:gap-x-1.5 lg:[&>.swiper-wrapper]:gap-y-10
            lg:border-b lg:border-black
            ${
              isExpanded
                ? 'lg:!pb-[61px]'
                : 'lg:[&>.swiper-wrapper]:grid-rows-[1fr_150px]'
            }
            `}
            modules={[Navigation]}
            navigation={{
              nextEl: '.swiper-similar-products-next',
              prevEl: '.swiper-similar-products-prev',
              disabledClass: '!opacity-50',
            }}
            slidesPerView={2.5}
            spaceBetween={6}
            breakpoints={{
              1024: {
                destroy: true,
              },
            }}
            onResize={(swiper) => {
              if (swiper.currentBreakpoint === '1024') {
                swiper.slideTo(0);
                swiper.disable();
              } else {
                swiper.enable();
              }
            }}
          >
            <div className="absolute flex items-center gap-1 right-0 -top-[42px] z-1">
              <button
                className={`swiper-button-prev swiper-similar-products-prev
                  !block cursor-pointer
                lg:!hidden rotate-180
                bg-transparent origin-center`}
              >
                <IconLookRight classes="stroke-2 md:stroke-1" />
              </button>
              <button
                className={`swiper-button-next swiper-similar-products-next
                  !block cursor-pointer lg:!hidden
                bg-transparent
              `}
              >
                <IconLookRight classes="stroke-2 md:stroke-1" />
              </button>
            </div>
            {products.map((product, index) => (
              <SwiperSlide
                key={index}
                className={`lg:!w-full ${
                  !isExpanded && index > 9 ? 'lg:!hidden' : ''
                } ${
                  !isExpanded && index > 4
                    ? 'lg:pointer-events-none lg:overflow-hidden'
                    : ''
                } ${index > 17 ? 'hidden lg:block' : ''}`}
              >
                <ProductCard product={product} swipeSlider={false} />
              </SwiperSlide>
            ))}
            <SwiperSlide className="lg:hidden text-center justify-center aspect-[2/3]">
              <a
                href={`/products/${handle}?view=for-you`}
                className="w-full h-full no-underline text-xs font-GTAmerica leading-[1.2] flex flex-col justify-center items-center gap-5 bg-gray-300"
              >
                <span className="flex items-center justify-center w-[24px] h-[24px] bg-white rounded-full border border-gray-800">
                  <IconPlus />
                </span>
                <span className="block mx-auto max-w-[100px] tracking-[0.1px] text-text-default">
                  {window.TMW.Strings.productListings.viewAllMobile}
                </span>
              </a>
            </SwiperSlide>
          </Swiper>
          {isExpanded ? (
            <a
              href={`/products/${handle}?view=for-you`}
              className="hidden no-underline w-fit mx-auto px-10 lg:block h-[42px] button text-center button--primary absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 z-1"
            >
              {window.TMW.Strings.productListings.viewAll}
            </a>
          ) : (
            <button
              onClick={handleExpandListings}
              className="no-underline hidden lg:block h-[42px] px-10 button text-center button--primary absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 z-1"
            >
              {window.TMW.Strings.productListings.viewMore}
            </button>
          )}
        </div>
      </div>
    )
  );
};

export default SimilarProducts;
